"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _TopicClusterApiClient = require("AudienceTargetingUIComponents/api/TopicClusterApiClient");

var FilterTopicSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterTopicSelect, _PureComponent);
  (0, _createClass2.default)(FilterTopicSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        size: _react.PropTypes.string,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        value: _react.PropTypes.instanceOf(_immutable.List)
      };
    }
  }]);

  function FilterTopicSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterTopicSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterTopicSelect).call(this, props));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      options: [],
      noTopics: false,
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterTopicSelect, [{
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        isInputValid: Boolean(e.target.value && e.target.value.length)
      });
      this.props.onChange(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.props.onBlur(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          size = _this$props.size,
          value = _this$props.value;

      var tooltipTitle = labelConfig.noTopics || _I18n.default.text(this.getLangKey('noTopics'));

      var placeholder = labelConfig.select || _I18n.default.text(this.getLangKey('select'));

      return _react.default.createElement(_UITooltip.default, {
        title: tooltipTitle,
        disabled: !this.state.noTopics
      }, _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input " + size
      }, _react.default.createElement(_UISelect.default, {
        disabled: this.state.noTopics,
        error: !this.state.isInputValid,
        onBlur: function onBlur(e) {
          var normalizedValue = _immutable.List.isList(value) ? value.toJS() : value;

          _this2.handleBlur(e);

          _this2.setState({
            isInputValid: Boolean(normalizedValue.length)
          });
        },
        onChange: this.handleChange,
        multi: true,
        multiCollapseLimit: 4,
        loadOptions: function loadOptions(input, callback) {
          (0, _TopicClusterApiClient.getClusters)(false).then(function (clusters) {
            var filteredResults = !input ? clusters : clusters.filter(function (cluster) {
              return cluster.coreTopic.phrase.indexOf(input) > -1;
            });
            var options = filteredResults.map(function (cluster) {
              return {
                text: cluster.coreTopic.phrase,
                value: cluster.coreTopic.phrase
              };
            }); // eslint-disable-next-line no-extra-boolean-cast

            var noTopics = !Boolean(options.length);

            _this2.setState({
              options: options,
              noTopics: noTopics
            });

            callback(null, {
              options: options
            });
          });
        },
        options: this.state.options,
        value: _immutable.List.isList(value) ? value.toJS() : value,
        placeholder: placeholder
      })));
    }
  }]);
  return FilterTopicSelect;
}(_react.PureComponent);

exports.default = FilterTopicSelect;
module.exports = exports.default;